import type {
  EncodingPreference,
  EphemeralTurnCredentials,
  SessionMode,
} from "@srd/shared";

const KEY = "srd.session.secrets";

export interface StashedSessionSecrets {
  sessionId: string;
  sessionJwt: string;
  turn: EphemeralTurnCredentials;
  deviceId: string;
  deviceName: string;
  mode: SessionMode;
  encodingPreference: EncodingPreference;
  expiresAt: string;
}

/**
 * Ephemeral hand-off from device list → session route.
 * Uses sessionStorage (tab-scoped); never localStorage. Cleared on end.
 */
export function stashSessionSecrets(secrets: StashedSessionSecrets): void {
  sessionStorage.setItem(KEY, JSON.stringify(secrets));
}

export function loadSessionSecrets(sessionId: string): StashedSessionSecrets | null {
  const raw = sessionStorage.getItem(KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as StashedSessionSecrets;
    if (parsed.sessionId !== sessionId) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearSessionSecrets(): void {
  sessionStorage.removeItem(KEY);
}
